// 环境配置文件 - 自动环境检测
export interface EnvConfig {
  isDevelopment: boolean;
  isProduction: boolean;
  apiBaseUrl: string;
  timeout: number;
}

// 自动检测环境
export const getEnvironment = (): 'development' | 'production' => {
  // 1. 检查 NODE_ENV
  if (process.env.NODE_ENV === 'development') {
    return 'development';
  }
  
  if (process.env.NODE_ENV === 'production') {
    return 'production';
  }
  
  // 2. 检查当前域名和端口
  if (typeof window !== 'undefined') {
    const hostname = window.location.hostname;
    const port = window.location.port;
    
    // 本地开发环境判断
    if (
      hostname === 'localhost' || 
      hostname === '127.0.0.1' || 
      hostname === '0.0.0.0' ||
      port === '8086' ||
      port === '3000' ||
      port === '8080'
    ) {
      return 'development';
    }
    
    // 生产环境
    return 'production';
  }
  
  // 默认返回生产环境
  return 'production';
};

// 获取环境配置
export const getEnvConfig = (): EnvConfig => {
  const environment = getEnvironment();
  const isDevelopment = environment === 'development';
  const isProduction = environment === 'production';
  
  // 获取API基础URL
  let apiBaseUrl = '/api';
  
  if (isProduction && typeof window !== 'undefined' && window.PROJECT_CONFIG) {
    const config = window.PROJECT_CONFIG;
    
    // 如果配置了具体的API地址
    if (config.BASE_API && config.BASE_API !== '/api/') {
      apiBaseUrl = config.BASE_API;
    } else if (config.BASE_API === '/api/') {
      apiBaseUrl = '/api';
    } else {
      // 自动构建生产环境API地址
      const protocol = window.location.protocol;
      const hostname = window.location.hostname;
      const port = window.location.port;
      
      apiBaseUrl = `${protocol}//${hostname}`;
      if (port && port !== '80' && port !== '443') {
        apiBaseUrl += `:${port}`;
      }
      apiBaseUrl += '/api';
    }
  }
  
  // 获取超时时间
  const timeout = (typeof window !== 'undefined' && window.PROJECT_CONFIG?.TIMEOUT) || 180000;
  
  return {
    isDevelopment,
    isProduction,
    apiBaseUrl,
    timeout
  };
};

// 导出当前环境配置
export const envConfig = getEnvConfig();

// 调试信息
if (typeof window !== 'undefined') {
  console.log('🔧 环境配置信息:', {
    环境: envConfig.isDevelopment ? '开发环境' : '生产环境',
    API地址: envConfig.apiBaseUrl,
    超时时间: envConfig.timeout + 'ms',
    当前域名: window.location.hostname,
    当前端口: window.location.port,
    当前协议: window.location.protocol
  });
}

